export class ReportsParameters {
    Id: number;
    Name: string;
    Brief: string;
    ReportsTypesId: number;
    SortOrder: number;
    createdAt: Date;
    updatedAt: Date;
    Type:string;
}